module.exports = __webpack_public_path__ + "img/alessandro.2888967e.png";